import { Status } from "@common/models";

export class ReportCategory {
    id?: number;
    name?: string;
    nameEnglish?: string;
    description?: string;
    status?: Status = new Status();
}
